var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.8653 0.814281C8.72969 0.567353 8.53186 0.361723 8.29219 0.21859C8.05253 0.0754564 7.77972 0 7.50188 0C7.22403 0 6.95122 0.0754564 6.71156 0.21859C6.4719 0.361723 6.27406 0.567353 6.13845 0.814281L0.198634 11.6331C0.0657662 11.8751 -0.00268051 12.1483 8.03314e-05 12.4255C0.00284117 12.7027 0.0767135 12.9744 0.214374 13.2136C0.352034 13.4528 0.548701 13.6512 0.784877 13.7891C1.02105 13.9271 1.28854 13.9998 1.56081 14H13.4379C13.7103 14 13.978 13.9275 14.2143 13.7896C14.4507 13.6518 14.6475 13.4534 14.7853 13.2141C14.9231 12.9749 14.9971 12.7031 14.9999 12.4258C15.0027 12.1485 14.9343 11.8752 14.8014 11.6331L8.8653 0.814281ZM8.4379 10.5006C8.4379 10.7537 8.33915 10.9965 8.16338 11.1755C7.98761 11.3544 7.74921 11.455 7.50063 11.455C7.25205 11.455 7.01365 11.3544 6.83787 11.1755C6.6621 10.9965 6.56335 10.7537 6.56335 10.5006C6.56335 10.2475 6.6621 10.0047 6.83787 9.82576C7.01365 9.64678 7.25205 9.54622 7.50063 9.54622C7.74921 9.54622 7.98761 9.64678 8.16338 9.82576C8.33915 10.0047 8.4379 10.2475 8.4379 10.5006ZM6.87578 7.63746V4.4562C6.87578 4.28745 6.94161 4.12562 7.05879 4.0063C7.17597 3.88698 7.33491 3.81994 7.50063 3.81994C7.66635 3.81994 7.82528 3.88698 7.94246 4.0063C8.05964 4.12562 8.12547 4.28745 8.12547 4.4562V7.63746C8.12547 7.80621 8.05964 7.96804 7.94246 8.08736C7.82528 8.20669 7.66635 8.27372 7.50063 8.27372C7.33491 8.27372 7.17597 8.20669 7.05879 8.08736C6.94161 7.96804 6.87578 7.80621 6.87578 7.63746Z",
    fill: "url(#paint0_linear_27_578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_578",
    x1: 13.9944,
    y1: 6.99998,
    x2: 0.377095,
    y2: 6.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFF70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d32763f59d8814b653a37928bc434654.svg";
export { ForwardRef as ReactComponent };